export default (initialState = {}) => {
  return () => {
    return {
      bill_id: null,
      bill_date: null,
      bill_number: "",
      billing_address: "",
      date: new Date(),
      dn_for: "bill",
      invc_id: null,
      invc_date: null,
      invc_number: "",
      lineitems: [],
      payment_terms: "",
      po_id: null,
      reference_invcs: [],
      remarks: "",
      shipping_address: "",
      tds: {},
      total_amount: null,
      total_tax: null,
      type: "Returns",
      type_cd: "returns",
      vehicle_number: "",
      ...initialState,
    };
  };
};
